<template>
    <div>
        <section class="ja__location">
            <label for="location" class="jas__label">Choose Your Location</label>
            <div id="location" class="location__selector">
                <input id="usa" type="radio" name="location" value="usa" :model="location" @click="location = 'usa'" :checked="location == 'usa'">
                <FormLabel for="usa" class="location__selector__col">
                    <label for="usa">
                        <span>United States</span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_1825_10024)"> <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/> <path d="M11.4785 12.0001H24.0002C24.0002 10.917 23.8559 9.86774 23.5868 8.86963H11.4785V12.0001Z" fill="#D80027"/> <path d="M11.4785 5.73836H22.239C21.5044 4.53968 20.5651 3.48016 19.47 2.60791H11.4785V5.73836Z" fill="#D80027"/> <path d="M12.0011 23.9998C14.8252 23.9998 17.421 23.0237 19.4709 21.3911H4.53125C6.58109 23.0237 9.17689 23.9998 12.0011 23.9998Z" fill="#D80027"/> <path d="M1.76195 18.2598H22.2394C22.8291 17.2975 23.2865 16.2457 23.5873 15.1294H0.414062C0.714859 16.2457 1.17222 17.2975 1.76195 18.2598Z" fill="#D80027"/> <path d="M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z" fill="#0052B4"/> </g> <defs> <clipPath id="clip0_1825_10024"> <rect width="24" height="24" fill="white"/> </clipPath> </defs> </svg></label>
                </FormLabel>
                <input id="Canada" type="radio" name="location" value="Canada" :model="location" @click="location = 'Canada'" :checked="location == 'Canada'">
                <FormLabel for="usa" class="location__selector__col">
                    <label for="Canada">
                        <span>Canada</span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_1825_10012)"> <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/> <path d="M23.9994 12.0007C23.9994 7.24316 21.2307 3.13241 17.2168 1.19141V22.8099C21.2307 20.869 23.9994 16.7582 23.9994 12.0007Z" fill="#D80027"/> <path d="M0 12.0002C0 16.7577 2.76867 20.8685 6.78262 22.8095V1.19092C2.76867 3.13192 0 7.24267 0 12.0002Z" fill="#D80027"/> <path d="M14.087 13.566L16.174 12.5225L15.1305 12.0008V10.9573L13.0435 12.0008L14.087 9.91384H13.0435L12.0001 8.34863L10.9566 9.91384H9.91309L10.9566 12.0008L8.86961 10.9573V12.0008L7.82617 12.5225L9.91309 13.566L9.39138 14.6095H11.4783V16.1747H12.5218V14.6095H14.6088L14.087 13.566Z" fill="#D80027"/> </g> <defs> <clipPath id="clip0_1825_10012"> <rect width="24" height="24" fill="white"/> </clipPath> </defs> </svg></label>
                </FormLabel>
                <input id="Overseas" type="radio" name="location" value="Overseas" :model="location" @click="location = 'Overseas'" :checked="location == 'Overseas'">
                <FormLabel for="Overseas" class="location__selector__col">
                    <label for="Overseas">
                        <span>Overseas</span>
                        <svg id="overseas" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.07598 7.48282L7.36402 10.5457C7.58715 10.705 7.69872 10.7847 7.81548 10.8031C7.91821 10.8192 8.02343 10.8029 8.11648 10.7565C8.22223 10.7037 8.30449 10.594 8.46901 10.3747L9.37511 9.16652C9.42164 9.10448 9.4449 9.07347 9.47224 9.04671C9.49652 9.02295 9.52315 9.00173 9.55173 8.98338C9.58392 8.9627 9.61935 8.94696 9.6902 8.91546L13.5588 7.19609C13.7192 7.12482 13.7993 7.08918 13.8598 7.03352C13.9133 6.9843 13.9554 6.924 13.9832 6.85684C14.0146 6.78091 14.0204 6.69336 14.0321 6.51826L14.3154 2.2694M13.5 13.5L16.116 14.6211C16.4195 14.7512 16.5713 14.8163 16.6517 14.9243C16.7222 15.0191 16.7569 15.1358 16.7496 15.2537C16.7413 15.3881 16.6497 15.5255 16.4665 15.8002L15.2375 17.6438C15.1507 17.774 15.1072 17.8391 15.0499 17.8863C14.9991 17.928 14.9406 17.9593 14.8777 17.9784C14.8067 18 14.7284 18 14.5719 18H12.5766C12.3693 18 12.2656 18 12.1774 17.9653C12.0995 17.9347 12.0305 17.885 11.9768 17.8208C11.916 17.7481 11.8832 17.6497 11.8177 17.453L11.1048 15.3144C11.0661 15.1983 11.0468 15.1403 11.0417 15.0814C11.0372 15.0291 11.0409 14.9764 11.0528 14.9253C11.0662 14.8677 11.0935 14.813 11.1482 14.7036L11.6897 13.6206C11.7997 13.4005 11.8547 13.2905 11.9395 13.2222C12.0141 13.162 12.1046 13.1246 12.1999 13.1143C12.3081 13.1027 12.4248 13.1416 12.6582 13.2194L13.5 13.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#0E1622" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/> </svg></label>
                </FormLabel>              
                <ErrorLabel field="custom.location" customError="Please select a Location" />
            </div>
        </section>
        <section class="ja__subscribeplan">
            <label for="Subscription"  class="jas__label">Choose Your Preferred Subscription Plan</label>
           <FormRow>
              <div class="sponsorship__list">
                <div class="amount-row">
                  <input
                    id="oneday"
                    type="radio"
                    class="amount"
                    @click="selectedAmount = oneYearPrice"
                    :checked="selectedAmount == oneYearPrice"
                  />
                  <FormLabel for="oneday">
                    <MoneyFormat
                      class="label-amount"
                      :value="oneYearPrice"
                      :currencyCode="form.currency || 'USD'"
                      :hide-subunits="true"
                    />
                    <span class="label-description">1 Year (4 Issues) </span>
                  </FormLabel>
                </div>
                <div class="amount-row">
                  <input
                    id="oneweek"
                    type="radio"
                    class="amount"
                    @click="selectedAmount = twoYearPrice"
                    :checked="selectedAmount == twoYearPrice"
                  />
                  <FormLabel for="oneweek">
                    <MoneyFormat
                      class="label-amount"
                      :value="twoYearPrice"
                      :currencyCode="form.currency || 'USD'"
                      :hide-subunits="true"
                    />
                    <span class="label-description">2 Years <strong>(8 Issues) </strong></span>
                  </FormLabel>
                </div>
              </div>

              <ErrorLabel field="amount" />
            </FormRow>
        </section>        
    </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {},
  setup() {
    const { setValue, getValue, form } = usePaymentForm();
    const params = queryParams();
    const selectedAmount = ref();
    const selectedDescription = ref();
    const customAmount = ref(form.value.amount);
    const customSelected = ref(false);
    const location = ref("usa");
    setValue("custom.location", "usa");
    setValue("custom.Notes", "1 Year (4 Issues) Plan");

    // Price mapping based on location
    const oneYearPrice = computed(() => {
      switch (location.value) {
        case 'Canada':
          return 20;
        case 'Overseas':
          return 60;
        case 'usa':
        default:
          return 16;
      }
    });

    const twoYearPrice = computed(() => {
      switch (location.value) {
        case 'Canada':
          return 32;
        case 'Overseas':
          return 105;
        case 'usa':
        default:
          return 28;
      }
    });
    
    

    watch(location, () => {
      if (location) {
        setValue("custom.location", location.value);
        // Reset selected amount to 1 year price when location changes
        selectedAmount.value = oneYearPrice.value;
        setValue("amount", "" + oneYearPrice.value);
      }
    });

    // setValue("amount", "100");
    // selectedAmount.value = 100;

    if (params.type) {
      //@ts-ignore
      switch (params.type) {
        case "1000":
          setValue("amount", "1000");
          selectedAmount.value = 1000;
          break;
        case "360":
          setValue("amount", "360");
          selectedAmount.value = 360;
          break;
        case "100":
          setValue("amount", "100");
          selectedAmount.value = 100;
          break;
        default:
          setValue("amount", "100");
          selectedAmount.value = 100;
      }
    } else {
      setValue("amount", "16");
      selectedAmount.value = 16;
    }

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false;

        customAmount.value = null;

        setValue("amount", "" + selectedAmount);

        // Update Notes based on selected plan
        if (selectedAmount === oneYearPrice.value) {
          setValue("custom.Notes", "1 Year (4 Issues) Plan");
        } else if (selectedAmount === twoYearPrice.value) {
          setValue("custom.Notes", "2 Years (8 Issues) Plan");
        }
      }
    });

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      // await Vue.nextTick();

      if (!selectedAmount.value) {
        setValue("amount", customAmount || null);
      }
    });

    return {
      form,
      selectedAmount,
      customAmount,
      customSelected,
      selectedDescription,
      currency: computed(() => form.value.currency),
      getValue,
      setValue,
      location,
      oneYearPrice,
      twoYearPrice
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep .location__selector{
  display: flex;
  align-items: center;
  input[type="radio"] {
    display: none;
  }
  input[type="radio"] + span {
    z-index: 10;
    margin: 0 0px 10px 0;
    padding: 7px 20px;
    border-radius: 4px;
    position: relative;
    color: #ced4da;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.1);
    font-weight: bold;
    background-color: #ffffff;
    border: 2px solid #ced4da;
    cursor: pointer;
    transition: all 200ms ease;
    &:hover {
        background: rgba(0, 0, 0, 0.05);
    }
  }
  input[type="radio"]:checked + label {
        color: var(--Grayscale-Off-white, #FDFDFD);
        text-align: center;
        font-family: "Merriweather";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        background: var(--Primary-Default, #18407C);
         label{
             color: var(--Grayscale-Off-white, #FDFDFD);
        text-align: center;
        font-family: "Merriweather";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        }
        svg#overseas path{
                stroke: white;
        }
  }

  label.location__selector__col span {
        @media only screen and (max-width: 720px) {
          display: none;
        }
  }
}
.location__selector__col {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 6px;
color: var(--Grayscale-Ash, #0E1622);
text-align: center;
font-family: "Merriweather";
font-size: 14px;
font-style: normal;
font-weight: 400;
border: 1px solid var(--Grayscale-Line, #CFD1D3);
display: flex;
height: 48px;
padding: 14px 24px 14px 32px;
line-height: 20px; /* 142.857% */  
&:hover{
    background: #F7F7F7;
}
&:first-of-type{
    border-radius: 99px 0 0 99px;
}
label{
    display: flex;
    align-items: center;
    gap: 6px;
}
&:last-of-type{
    border-radius: 0 32px 32px 0;
}
}

label.jas__label{
    color: var(--Grayscale-Placehold, #96999C);
margin-bottom: 0px;
padding-bottom: 8px;
/* Desktop/Text/Label */
font-family: "Merriweather";
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 142.857% */
}

.ja__location{
    margin-bottom: 32px;
}

.ja__subscribeplan{
    padding-bottom: 40px;
    border-bottom: 1px solid #EDEDED;
    margin-bottom: 40px;
}

.sponsorship__list {
    display: flex;
    gap: 16px;
    .amount-row{
        input[type=radio]{
            display: none;
        }
        label{
            display: flex;
            padding:10px 12px;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: 8px;
            flex-shrink: 0;            
                border-radius: 2px;
                border: 2px solid var(--Grayscale-Input, #EBEBEB);
                cursor: pointer;   
                                	  @media only screen and (max-width: 720px) {
                                      flex: 1;
                                    }
                	  @media only screen and (min-width: 720px) {
            width: 215px;
            height: 102px;
            padding: 20px 24px;
                    }
                .money_format.label-amount{
                    color: var(--Grayscale-Ash, #080F16);
                    text-align: center;
                    font-family: "Oswald";
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 26px; /* 130% */                    
                }
                span.label-description {
                    color: var(--Grayscale-Body, #595C5F);
                    text-align: center;
                    font-family: "Merriweather";
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 150%;
                }  
                &:hover{
                        border-radius: 2px;
                        border: 2px solid var(--Grayscale-Line, #CFD1D3);
                        background: var(--White, #FFF);
                }              
        }
          input[type="radio"]:checked + label {
                border-radius: 2px;
                border: 2px solid var(--Primary-Default, #1E50B4);
                background: var(--White, #FFF);

                .money_format.label-amount{
                    color: var(--Grayscale-Ash, #080F16);
                    color: var(--Primary-Default, #1E50B4);
                }
          }
    }
}

</style>
